// extracted by mini-css-extract-plugin
export default {"checkboxWrapper":"index_checkboxWrapper__ERE6m"};